<div class="simple-text">
  <ng-container *ngIf="message; else content">
    {{ message }}
  </ng-container>
  <ng-template #content>
    <ng-container *ngIf="!error()?.custom">
      <ng-content></ng-content>
    </ng-container>
    {{ errorMessage() }}
  </ng-template>
</div>
